<template>
  <div v-if="modelValue" dir="rtl" class="col-lg-12 modal__for_fn rounded"
       :style="loading ? 'filter: blur(0.3vw);' : ''" style="width: 40vw; height: 40vw;">
    <div class="card card-body card-panel-box border-0 rounded"
         style="background-color: #F4FCFF; margin: 0; height: 40vw">
      <div class="row" style="height: 40vw">
        <div class="col-lg-12 ps-1" style="height: 40vw">
          <div class="card card-body card-panel-box border-0" style="height: 36vw;overflow-y: scroll">
            <h2 style="font-size: 1.2vw !important;">لطفا اطلاعات کاربر را وارد نمایید</h2>
            <form class="needs-validation" novalidate>
              <div class="row">
                <div class="col-lg-6 mb-3">
                  <label class="form-label required">کد پرسنلی</label>
                  <input v-model="formData.personal_code" class="form-control" type="text" required>
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label required">کدملی</label>
                  <input v-model="formData.national_code" class="form-control" type="text" required>
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label required">نام</label>
                  <input v-model="formData.firstname" class="form-control" type="text" required>
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label required">نام خانوادگی</label>
                  <input v-model="formData.lastname" class="form-control" type="text" required>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 mb-3">
                  <label class="form-label">فایل امضا ( JPG , JPEG ,PNG )</label>
                  <input id="file2" ref="fileInput" class="form-control d-block" type="file" required>
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label ">تصویر پروفایل ( JPG , JPEG ,PNG )</label>
                  <input id="file_profile2" ref="fileProfileInput" class="form-control d-block" type="file"
                         accept="image/png, .jpg, .jpeg">
                </div>
              </div>

              <!-- Start/End Date -->
              <div class="row">
                <div class="col-lg-6 mb-3">
                  <label class="form-label">شروع فعالیت</label>
                  <Vue3PersianDatetimePicker v-model="formData.start_date"></Vue3PersianDatetimePicker>
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label">پایان فعالیت</label>
                  <Vue3PersianDatetimePicker v-model="formData.end_date"></Vue3PersianDatetimePicker>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 mb-3">
                  <label class="form-label">بارگذاری حکم ( JPG , JPEG ,PNG )</label>
                  <input id="decree_file" ref="decreeFileInput" class="form-control d-block" type="file">
                </div>
              </div>

              <!-- Contact Info -->
              <div class="row">
                <div class="col-lg-6 mb-3">
                  <label class="form-label">تلفن همراه</label>
                  <input v-model="formData.phone" class="form-control" >
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label">تلفن ثابت</label>
                  <input v-model="formData.tel" class="form-control" >
                </div>
              </div>

              <!-- Additional Info -->
              <div class="row">
                <div class="col-lg-6 mb-3">
                  <label class="form-label">کد خط داخلی</label>
                  <input v-model="formData.code_tel" class="form-control" type="text">
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label">محل فعالیت</label>
                  <input v-model="formData.address_activity" class="form-control" type="text">
                </div>
              </div>

              <!-- Position & Notes -->
              <div class="row">
                <div class="col-lg-6 mb-3">
                  <label class="form-label">سمت</label>
                  <input v-model="formData.post" class="form-control" type="text">
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label">یادداشت</label>
                  <input v-model="formData.note" class="form-control" type="text">
                </div>
              </div>

              <!-- Education & Work History -->
              <div class="row">
                <div class="col-lg-6 mb-3">
                  <label class="form-label">تحصیلات</label>
                  <input v-model="formData.edu_level" class="form-control" type="text">
                </div>
                <div class="col-lg-6 mb-3">
                  <label class="form-label">سابقه کار</label>
                  <input v-model="formData.work_history_time" class="form-control" type="text">
                </div>
              </div>

              <!-- Course Management -->
              <div class="row">
                <div class="col-lg-12 mb-3">
                  <label class="form-label ">
                    دوره آموزشی چرخه مدیریت بهره‌وری را با موفقیت پشت‌سر گذاشته‌اند؟
                  </label>
                  <select v-model="formData.course_management" class="form-select">
                    <option value="" disabled selected>انتخاب کنید</option>
                    <option :value="1">بله</option>
                    <option :value="0">خیر</option>
                  </select>
                </div>
              </div>

              <div v-if="formData.course_management === 1">
                <!-- Intro Course Info -->
                <h4 style="font-size: 1vw !important">تکمیل اطلاعات دوره مقدماتی</h4>
                <div class="row">
                  <div class="col-lg-4 mb-3">
                    <label class="form-label required">تاریخ</label>
                    <Vue3PersianDatetimePicker v-model="formData.intro_date"></Vue3PersianDatetimePicker>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <label class="form-label required">مکان</label>
                    <textarea v-model="formData.intro_location" class="form-control" rows="3"></textarea>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <label class="form-label required">گواهینامه</label>
                    <select v-model="formData.has_intro_certificate" class="form-select">
                      <option value="" disabled selected>انتخاب کنید</option>
                      <option :value="1">دارد</option>
                      <option :value="0">ندارد</option>
                    </select>
                  </div>
                </div>
                <div class="row" v-if="formData.has_intro_certificate === 1">
                  <div class="col-lg-12 mb-3">
                    <label class="form-label">بارگذاری گواهینامه دوره مقدماتی ( JPG , JPEG ,PNG )</label>
                    <input id="intro_certificate_file" ref="introCertFileInput" class="form-control d-block"
                           type="file">
                  </div>
                </div>

                <!-- Supplementary Course Info -->
                <h4 style="font-size: 1vw !important" class="mt-3">تکمیل اطلاعات دوره تکمیلی</h4>
                <div class="row">
                  <div class="col-lg-4 mb-3">
                    <label class="form-label required">تاریخ</label>
                    <Vue3PersianDatetimePicker v-model="formData.supplementary_date"></Vue3PersianDatetimePicker>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <label class="form-label required">مکان</label>
                    <textarea v-model="formData.supplementary_location" class="form-control" rows="3"></textarea>
                  </div>
                  <div class="col-lg-4 mb-3">
                    <label class="form-label required">گواهینامه</label>
                    <select v-model="formData.has_supplementary_certificate" class="form-select">
                      <option value="" disabled selected>انتخاب کنید</option>
                      <option :value="1">دارد</option>
                      <option :value="0">ندارد</option>
                    </select>
                  </div>
                </div>
                <div class="row" v-if="formData.has_supplementary_certificate === 1">
                  <div class="col-lg-12 mb-3">
                    <label class="form-label">بارگذاری گواهینامه دوره تکمیلی ( JPG , JPEG ,PNG )</label>
                    <input id="supplementary_certificate_file" ref="suppCertFileInput" class="form-control d-block"
                           type="file">
                  </div>
                </div>
              </div>

              <!-- Form Buttons -->
              <div class="form-buttons row d-flex justify-content-around">
                <button @click.prevent="closeModal" class="btn btn-primary btn-back">برگشت</button>
                <button @click.prevent="submitForm" class="btn btn-primary btn-approve justify-content-evenly">
                  تایید
                  <span v-show="loading" class="loader"></span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, reactive} from 'vue'
import {useToast} from "vue-toastification";
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import cookies from "vue-cookies";
import {base_url} from "@/main";

export default {
  name: 'UserCreateForm',

  components: {Vue3PersianDatetimePicker},

  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    companyId: {
      type: Number,
      required: false,
      default: null,
    },
  },

  emits: ['update:modelValue', 'user-created', 'close-modal'],

  setup(props, {emit}) {
    const toast = useToast()
    const loading = ref(false)
    const fileInput = ref(null)
    const fileProfileInput = ref(null)
    const decreeFileInput = ref(null)
    const introCertFileInput = ref(null)
    const suppCertFileInput = ref(null)

    const formData = reactive({
      personal_code: '',
      national_code: '',
      firstname: '',
      lastname: '',
      start_date: '',
      end_date: '',
      phone: '',
      tel: '',
      code_tel: '',
      address_activity: '',
      post: '',
      note: '',
      edu_level: '',
      work_history_time: '',
      course_management: '',
      intro_date: '',
      intro_location: '',
      has_intro_certificate: '',
      supplementary_date: '',
      supplementary_location: '',
      has_supplementary_certificate: ''
    })

    const validateRequiredFields = () => {
      if (!formData.personal_code) {
        toast.error('کد پرسنلی اجباری است!')
        return false
      }
      if (!formData.national_code) {
        toast.error('کدملی اجباری است!')
        return false
      }
      if (!formData.firstname) {
        toast.error('نام اجباری است!')
        return false
      }
      if (!formData.lastname) {
        toast.error('نام خانوادگی اجباری است!')
        return false
      }
      return true
    }

    const resetForm = () => {
      Object.keys(formData).forEach(key => {
        formData[key] = ''
      })
      if (fileInput.value) fileInput.value.value = ''
      if (fileProfileInput.value) fileProfileInput.value.value = ''
      if (decreeFileInput.value) decreeFileInput.value.value = ''
      if (introCertFileInput.value) introCertFileInput.value.value = ''
      if (suppCertFileInput.value) suppCertFileInput.value.value = ''
    }

    const closeModal = () => {
      resetForm()
      emit('close-modal')
      emit('update:modelValue', false)
    }

    const handleError = (error) => {
      const message = 'عملیات با موفقیت انجام نشد.'
      if (error.error) {
        toast.error(error.error)
        throw new Error(message)
      }

      if (error.errors) {
        Object.entries(error.errors).forEach((value) => {
          toast.error(value[1][0])
        })
        throw new Error(message)
      }
    }

    const submitForm = async () => {
      if (!validateRequiredFields()) return
      loading.value = true
      const submitData = new FormData()

      // Append all form data
      Object.keys(formData).forEach(key => {
        submitData.append(key, formData[key])
      })
      submitData.append('fullname', formData.firstname + ' ' + formData.lastname);
      submitData.append('company_id', props.companyId);

      // Append files
      if (fileInput.value?.files[0]) {
        submitData.append('file', fileInput.value.files[0])
      }
      if (fileProfileInput.value?.files[0]) {
        submitData.append('file_profile', fileProfileInput.value.files[0])
      }
      if (decreeFileInput.value?.files[0]) {
        submitData.append('decree_file', decreeFileInput.value.files[0])
      }
      if (introCertFileInput.value?.files[0]) {
        submitData.append('intro_certificate_file', introCertFileInput.value.files[0])
      }
      if (suppCertFileInput.value?.files[0]) {
        submitData.append('supplementary_certificate_file', suppCertFileInput.value.files[0])
      }

      try {
        const response = await fetch(`${base_url}/user/store`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            "Authorization": `Bearer ${cookies.get('token')}`,
          },
          body: submitData,
        })

        const data = await response.json()

        handleError(data)

        toast.success('کاربر با موفقیت اضافه شد!')
        emit('user-created')
        closeModal()
      } catch (error) {
        console.error(error)
      } finally {
        loading.value = false
      }
    }

    return {
      loading,
      formData,
      fileInput,
      fileProfileInput,
      decreeFileInput,
      introCertFileInput,
      suppCertFileInput,
      submitForm,
      closeModal
    }
  }
}
</script>
